import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_DM_REPUTATION_LAYER = defineFcm('dm_reputation_layer')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean' },
			},
		}),
	)
	.withDefault({
		enabled: false,
	})
	.withMerger(({ localeValue, countryValue, globalValue }) => ({
		// Priority: If either locale OR country are enabled, use that
		// If neither are enabled, falls back to global value
		enabled: localeValue.enabled || countryValue.enabled || globalValue.enabled,
	}))
	.toConfig();
